class RotatingBanner extends HTMLElement {
    connectedCallback() {
      this.slider = this.querySelector('#announcement-bar-slider');

      if (this.slider) {
        this.initSlider();
      }
    }

    disconnectedCallback() {
      if (this.slider && $(this.slider).hasClass('slick-initialized')) {
        $(this.slider).slick('unslick');
      }
    }

    initSlider() {
      const autoplayEnabled = this.slider.dataset.autoplay == 'true';
      const autoplaySpeed = parseInt(this.slider.dataset.autoplaySpeed);
      const arrowsEnabled = this.slider.dataset.arrows != 'false';
      $(this.slider).slick({
        autoplay: autoplayEnabled,
        autoplaySpeed: autoplaySpeed,
        dots: false,
        arrows: arrowsEnabled,
        slidesToShow: 1,
        slidesToScroll: 1,
        // Fixed height (tallest slide): animating the bar's height on every rotation shifts the page below it
        adaptiveHeight: false,
      });
    }
  }

  if (!customElements.get('rotating-banner')) {
    customElements.define('rotating-banner', RotatingBanner);
  }
